import api from '../../../services/Api';
import { IAuditoriaClassificacaoReceitaResultado } from '../interfaces/IAuditoriaClassificacaoReceita';

export const AuditoriaClassificacaoReceitaService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaClassificacaoReceitaResultado> {
    const response = await api.get<IAuditoriaClassificacaoReceitaResultado>('auditoria-classificacao-receita/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoFiscal: '',
        fundamentacaoContabil: '',
        classificacoesIndevidas: [],
        contasConciliadas: [],
      }
    );
  },
};
